import React from 'react';
import { useSelector } from 'react-redux';
import { Box, ModalFooter, Text } from '@chakra-ui/react';

import ConfirmDontAskAgainButtons from '../components/Modal/ModalButtonGroups/ConfirmDontAskAgainButtons';
import { selectModalButtons, showModal } from '../redux/modules/modal';

export const showDontAskAgainModal = ({ dispatch, cookieId, description, onClick, title }) => {
  if (document.cookie.indexOf(cookieId) < 0) {
    dispatch(showModal(
      () => {
        const { primaryButtonOptions } = useSelector(selectModalButtons);

        return (
          <>
            <Box pt={2}>
              <Text fontSize="md" pb={4}>
                {description}
              </Text>
            </Box>
            <ModalFooter>
              <ConfirmDontAskAgainButtons cookieId={cookieId} isLoading={primaryButtonOptions?.isLoading} onClick={onClick} />
            </ModalFooter>
          </>
        );
      },
      {
        size: 'md',
        title
      }
    ));
  } else {
    onClick();
  }
};
